<template>
  <div class="row">
    <div class="modal fade" id="changePassModal" style="z-index: 1500;">
      <div class="modal-dialog modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title">Cập nhật mật khẩu</h4>
                  <button type="button" class="close" aria-label="Close" @click="hideChangePassModal()">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="row mb-2">
                    <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                        Mật khẩu cũ <span class="text-danger">(*)</span>
                    </label>
                    <div class="col-sm-9">
                        <input class="form-control" type="password" placeholder="Nhập mật khẩu cũ" v-model="password" @blur="validateChangePass()" :class="{ 'is-invalid': errors.password }" autocomplete="current-password"/>
                    </div>
                  </div>
                  <small class="text-danger text-right mb-2 d-block" v-if="errors.password">{{ errors.password }}</small>

                  <div class="row mb-2">
                      <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                          Mật khẩu mới <span class="text-danger">(*)</span>
                      </label>
                      <div class="col-sm-9">
                          <input class="form-control" type="password" placeholder="Nhập mật khẩu mới" v-model="passwordNew" @blur="validateChangePass()" :class="{ 'is-invalid': errors.passwordNew }" autocomplete="new-password"/>
                      </div>
                  </div>
                  <small class="text-danger text-right mb-2 d-block" v-if="errors.passwordNew">{{ errors.passwordNew }}</small>

                  <div class="row mb-2">
                      <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                          Xác nhận mật khẩu <span class="text-danger">(*)</span>
                      </label>
                      <div class="col-sm-9">
                          <input class="form-control" type="password" placeholder="Nhập lại mật khẩu" v-model="passwordNewConfirmed" @blur="validateChangePass()" :class="{ 'is-invalid': errors.passwordNewConfirmed }" autocomplete="new-password"/>
                      </div>
                  </div>
                  <small class="text-danger text-right mb-2 d-block" v-if="errors.passwordNewConfirmed">{{ errors.passwordNewConfirmed }}</small>
                </form>
              </div>
              <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-outline-dark pull-left" data-dismiss="modal">&nbsp;Đóng</button>
                  <button type="button" class="btn btn-outline-primary pull-right" :disabled="submitted" @click="onSubmitChangePass();">
                      <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      &nbsp;Cập nhật
                  </button>
              </div>
          </div>
      </div>
    </div>
  </div>


</template>

<script>
import $ from 'jquery';
import common from '@/helper/common';

import { mapState, mapActions } from 'vuex';
export default {
  name: "TheChangePassword",
  data() {
    return {
      submitted: false,

      password: "",
      passwordNew: "",
      passwordNewConfirmed: "",
      errors: {},
    }
  },
  computed: {
    ...mapState({
      user: state => state.authentication.user
    })
  },
  methods: {
    ...mapActions('user', ['changePass',]),

    hideChangePassModal(){
      $('#changePassModal').modal('hide');
    },

    validateChangePass() {
      let isvalid = true
      this.errors = {
        password: '',
        passwordNew: '',
        passwordNewConfirmed: '',
      };

      // check null model
      if (!this.password) {
        this.errors.password = "Nhập mật khẩu cũ";
        isvalid = false;
      }

      if (!common.validatePassword(this.passwordNew)) {
        this.errors.passwordNew = "Mật khẩu phải có độ dài 8 kí tự trở lên, có chứa số, kí tự đặc biệt, kí tự hoa và thường";
        isvalid = false;
      }

      if (this.passwordNew != this.passwordNewConfirmed) {
        this.errors.passwordNewConfirmed = "Mật khẩu không khớp";
        isvalid = false;
      }

      return isvalid;
    },

    async onSubmitChangePass() {
      this.submitted = true;
      if (await this.validateChangePass()) {
        await this.changePass({ password: this.password, passwordNew: this.passwordNew, passwordNewConfirmed: this.passwordNewConfirmed });
        this.hideChangePassModal();
      }
      this.submitted = false;
    },
  },
  mounted() {
    
  }
}
</script>

<style>
</style>